import React from 'react';

import { Dropdown } from 'semantic-ui-react';

import FieldWrapper from './fieldWrapper';

class DropdownField extends React.Component {
    render() {
        const { value, onChange, placeholder, options, label, validation, error, errorMessage, onBlur, inputSub, popup, loading, search, onFocus, disabled } = this.props;

        return (
            <FieldWrapper label={label}
                validation={validation}
                error={error}
                errorMessage={errorMessage}
                onBlur={onBlur}
                inputSub={inputSub}
                popup={popup}
                value={value}>
                <Dropdown selection
                    onFocus={onFocus}
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    options={options}
                    loading={loading}
                    search
                    onSearchChange={search}
                    disabled={disabled} />
            </FieldWrapper>
        );
    }
}

export default DropdownField;